import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "euler-dao",
    {
      name: "Euler DAO",
      logo: "entities/euler.svg",
      description:
        "The Euler DAO is the organisation responsible for the creation of the Euler lending/borrowing platform.",
      url: "https://euler.finance/",
      addresses: {
        "0xfD30738fcB5eb5Ba418a84e672007912F991E539": "Euler DAO Multisig",
        "0x9b3CeB22Cab2F1b9Ace4CD3132C8a123552eDa2c":
          "Euler Vault Access Control Governor",
      },
      social: {
        twitter: "eulerfinance",
        youtube: "EulerFinance",
        discord: "https://discord.euler.finance/",
        telegram: "eulerfinance_official",
        github: "euler-xyz",
      },
    },
  ],
  [
    "gauntlet",
    {
      name: "Gauntlet",
      logo: "entities/gauntlet.svg",
      description:
        "Gauntlet's applied research and optimization teams model market risk, economic incentives, and drive sustainable growth for crypto's top protocols, chains, and onchain treasuries.",
      url: "https://www.gauntlet.xyz/",
      addresses: {
        "0x9b3CeB22Cab2F1b9Ace4CD3132C8a123552eDa2c":
          "Euler Vault Access Control Governor",
      },
      social: { twitter: "gauntlet_xyz" },
    },
  ],
  [
    "k3",
    {
      name: "K3 Capital",
      logo: "entities/k3.svg",
      description:
        "K3 Capital provide leading institutional asset and risk management in decentralized finance.",
      url: "https://k3.capital/",
      addresses: {
        "0x060DB084bF41872861f175d83f3cb1B5566dfEA3": "K3 Capital Multisig",
      },
      social: { twitter: "k3_capital" },
    },
  ],
  [
    "alphaping",
    {
      name: "AlphaPing",
      logo: "entities/alphaping.svg",
      description:
        "This is a performance-driven vault focusing on maximizing risk-adjusted returns for USDT. By allocating capital to high-conviction strategies and supporting the creation of deep, tradable markets, this vault serves as a foundation for sustainable liquidity growth and long-term yield optimization.",
      url: "https://alphaping.ch/",
      addresses: {
        "0xEB4Af6fA3AFA08B10d593EC8fF87efB03BC04645": "Alphaping Multisig",
      },
      social: { twitter: "0xAlphaping" },
    },
  ],
  [
    "re7-labs",
    {
      name: "Re7 Labs",
      logo: "entities/re7labs.png",
      description:
        "Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to on-chain vaults.",
      url: "https://www.re7labs.xyz/",
      addresses: {
        "0xddedB1F2d1dd0b0455Fe5277632c84f57f894011": "Re7 Labs Multisig",
      },
      social: { twitter: "Re7Labs" },
    },
  ],
  [
    "telosc",
    {
      name: "TelosC",
      logo: "entities/telosc.svg",
      description:
        "Engineered growth for crypto. Incentives, risk frameworks, and GTM for DeFi. Driving real users, TVL & revenue.",
      url: "https://telosc.com/",
      addresses: {
        "0x7d07BFdd01422D7b655B333157eB551B9712dCd8": "TelosC Multisig",
      },
      social: { twitter: "TelosConsilium" },
    },
  ],
  [
    "edge-capital",
    {
      name: "Edge UltraYield",
      logo: "entities/edge.png",
      description:
        "Edge Capital is a leading market-neutral hedge fund that manages capital for largest fund of funds, institutional investors and leading crypto foundations and treasuries since 2020",
      url: "https://edgecapital.xyz/",
      addresses: {
        "0x1280e86Cd7787FfA55d37759C0342F8CD3c7594a": "Edge Capital Multisig",
      },
      social: { twitter: "EdgeCapitalMgmt" },
    },
  ],
  [
    "hyperithm",
    {
      name: "Hyperithm",
      logo: "entities/hyperithm.png",
      description:
        "Hyperithm maximizes yield by swiftly integrating unique collaterals, providing borrowers with high-return opportunities through active optimization while ensuring effective risk management.",
      url: "https://www.hyperithm.com/",
      addresses: {
        "0x75178137D3B4B9A0F771E0e149b00fB8167BA325": "Hyperithm MPC wallet",
        "0xEe7E9bb21D5589BF657b94083dB2fA349a3918C8": "Hyperithm Multisig",
      },
      social: { twitter: "hyperithm" },
    },
  ],
  [
    "clearstar",
    {
      name: "Clearstar",
      logo: "entities/clearstar.svg",
      description:
        "Designing and curating institutional-grade strategies across decentralized markets, underpinned by rigorous risk management.",
      url: "https://www.clearstar.xyz/",
      addresses: {
        "0x30988479C2E6a03E7fB65138b94762D41a733458":
          "Curator Wallet 1 (ForDeFi MPC)",
        "0x72882eb5D27C7088DFA6DDE941DD42e5d184F0ef":
          "Curator Wallet 2 (ForDeFi MPC)",
      },
      social: { twitter: "ClearstarLabs" },
    },
  ],
])
